var Setup;
(function (Setup) {
    Setup["Finance"] = "FINANCE";
})(Setup || (Setup = {}));
export default Setup;
